import { useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { Mail, ArrowRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"
import { Link } from "react-router-dom";


function NewForgotPassword() {
    const emailRef = useRef(null);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [emailError, setEmailError] = useState("");

    const API = process.env.REACT_APP_API_URL;

    const validateEmail = (email) => {
    setEmailError("");

    if (!email) {
        setEmailError("Email is required");
        return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        setEmailError("Please enter a valid email address");
        return false;
    }

    const [, domain] = email.split('@');
    if (domain) {
        const domainParts = domain.split('.');
        if (domainParts[domainParts.length - 1].length < 2) {
        setEmailError("Invalid email domain");
        return false;
        }
    }

    return true;
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value.trim();

    // Validate email before submission
    if (!validateEmail(email)) {
        return;
    }

    setLoading(true);
    setMessage("");
    setError("");

    try {
        const response = await fetch(`${API}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
        });

        if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
        }

        const data = await response.json();
        setMessage(data.message || "Password reset link sent to your email.");
    } catch (err) {
        setError(err.message);
    } finally {
        setLoading(false);
    }
    };

    const handleEmailChange = (e) => {
    const email = e.target.value.trim();
    if (email) {
        validateEmail(email);
    } else {
        setEmailError("");
    }
    };

  const slides = [
    {
      title: ()=><>Welcome to <br /> 
       <span style={{ color: "#260efcff" }}>Hunarho {" "}</span>
       <span style={{ color: "#2D3748" }}>LMS</span>.
      </>,
      description:
        "Platform designed to help organizations, educators, and learners to track learning.",
      illustration: "login",
    },
    {
      title: ()=><>Learn at Your Own Pace.</>,
      description:
        "Access courses anytime, anywhere with our flexible learning platform for education.",
      illustration: "learning",
    },
    {
      title: ()=><>Track Your Progress</>,
      description: "Monitor your learning journey with detailed analytics and progress tracking tools.",
      illustration: "progress",
    },
  ]

  return (
    <>
      <div className="min-vh-100 overflow-hidden">
        <div className="container-fluid h-100 p-0">
          <div className="row g-0 h-100 flex-nowrap">
            <div className="col-lg-6 d-none d-lg-flex position-fixed top-0 start-0" style={{ background: "#e8f0fe", height: "100vh", overflow: "hidden"  }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 10000, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                loop={true}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 10 },
                  768: { slidesPerView: 1, spaceBetween: 20 },
                  1200: { slidesPerView: 1, spaceBetween: 30 },
                }}
                className="w-100 h-100"
              >
                {slides.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <div className="text-center">
                        <div className="mb-4 position-relative">
                          <img
                            src="/auth/auth-1.svg"
                            className="img-fluid"
                            width={430}
                            height={350}
                            alt={slide.illustration}
                          />
                        </div>

                        <h2
                          className="fw-bold mb-3 text-balance"
                          style={{ fontSize: "2.5rem", color: "#2D3748", lineHeight: "1.2" }}
                        >
                          {slide.title()}
                        </h2>
                        <p
                          className="mb-4 text-pretty"
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.6",
                            fontWeight: "400",
                            maxWidth: "558px",
                            margin: "auto",
                          }}
                        >
                          {slide.description}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>


            <div className="col-lg-6 offset-lg-6 col-12 d-flex align-items-center justify-content-center bg-white" style={{ minHeight: isMobile ? "80vh":"100vh", overflowY: "auto" }}>
              <div className="w-100 p-3 p-md-1" style={{ maxWidth: "450px" }}>
                <div className="d-flex justify-content-between align-items-center mb-4 mb-lg-5">
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex align-items-center justify-content-center me-3"
                    >
                      <img src="/assets/images/certificate/certificate_logo.png" width={180} height={40}/>
                    </div>
                  </div>
                </div>

                <div className="login-form">
                  <h3 className="fw-bold text-balance" style={{ color: "#2D3748", fontSize: "2rem", lineHeight: "1.3" }}>
                  Forgot Password?
                  </h3>
                  <p className="text-muted mb-2">Enter your email to reset your password</p>
                 
                  <form onSubmit={handleSubmit} noValidate>
                    <div className="mb-3">
                      <label
                        htmlFor="email"
                        className="form-label fw-semibold mb-2"
                        style={{ color: "#4A5568", fontSize: "0.95rem" }}
                      >
                        Email <span style={{ color: "#260efcff" }}>*</span>
                      </label>
                      <div className="position-relative">
                        <input
                          type="email"
                          ref={emailRef}
                          className={`form-control form-control-lg pe-5 ${emailError ? 'is-invalid' : ''}`}
                          id="email"
                          onChange={handleEmailChange}
                          placeholder="Enter your email"
                          required
                          aria-describedby="emailHelp emailFeedback"
                          style={{
                            border: "2px solid #E2E8F0",
                            borderRadius: "12px",
                            padding: "14px 50px 14px 16px",
                            fontSize: "1rem",
                            transition: "border-color 0.2s ease",
                          }}
                          onFocus={(e) => (e.target.style.borderColor = "#260efcff")}
                          onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")}
                        />
                        {!emailError &&<Mail
                          size={20}
                          className="position-absolute top-50 end-0 translate-middle-y me-3"
                          style={{ color: "#A0AEC0" }}
                        />}
                      </div>
                       {emailError && (
                            <div id="emailFeedback" className="invalid-feedback">
                            {emailError}
                            </div>
                        )}
                        <small id="emailHelp" className="form-text text-muted">
                            We'll never share your email with anyone else.
                        </small>
                    </div>
                    {(message || error) && (
                    <div className={`mb-3 ${message ? 'text-danger' : 'text-success'}`}>
                        {message || error}
                    </div>
                    )}

                    <button
                      type="submit"
                      className="btn btn-lg w-100 mb-4 text-white d-flex align-items-center justify-content-center fw-semibold"
                      style={{
                        background: "linear-gradient(135deg, #260efcff 0%, #2b05ffff 80%)",
                        backgroundColor: "#260efcff !important",
                        border: "none",
                        borderRadius: "12px",
                        padding: "14px",
                        fontSize: "1.1rem",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                      }}
                      disabled={loading || emailError}
                    >
                        
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Sending...
                        </>
                      ) : (<>Reset <ArrowRight size={20} className="ms-2" /></>)}
                    </button>

                    <div className="text-center">
                      <span className="fw-medium" style={{ color: "#0d0d0eff", fontSize: "0.95rem" }}>
                        Remember your password?{" "}
                      </span>
                      <Link
                        to="/login"
                        className="text-decoration-none fw-semibold"
                        style={{ color: "#260efcff", fontSize: "0.95rem" }}
                      >
                        Sign In
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NewForgotPassword
